import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { USER_ROLES_OPTIONS } from '../../../../shared/constants/constants';
import { ProfileDetails } from '../../../../shared/models/profile.model';
import { ProfileService } from '../../../../shared/services/profile.service';
import { UserService } from '../../../../shared/services/user.service';
import { SharedModule } from '../../../../shared/shared.module';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    SharedModule,
    ButtonComponent,
    ButtonLoaderComponent,
    InputWrapperComponent,
    NgxMaskDirective,
    ModalComponent,
    ChangePasswordComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit, OnDestroy {
  userForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', []],
    phone: ['', [Validators.required]],
    role: [{ value: '', disabled: true }],
  });
  isLoading: boolean = false;
  roles = USER_ROLES_OPTIONS;
  subscriptions = new Subscription();
  initialDetails: ProfileDetails | null = null;
  showPasswordModal: boolean = false;
  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private userService: UserService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscribeToProfileDetails();
  }

  subscribeToProfileDetails() {
    const sub = this.profileService.profileDetails.subscribe((value) => {
      this.initialDetails = value;
      this.userForm.patchValue({
        name: value?.name,
        email: value?.email,
        phone: value?.phone,
        role: value?.role,
      });
    });
    this.subscriptions.add(sub);
  }

  onSubmit() {
    if (!this.userForm.valid || this.isLoading) {
      this.userForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;

    this.userService
      .updateUser({
        name: this.userForm.value.name,
        phone: this.userForm.value.phone,
      })
      .subscribe({
        next: (res) => {
          if (this.initialDetails) {
            this.initialDetails = {
              ...this.initialDetails,
              name: this.userForm.value.name || '',
              phone: this.userForm.value.phone || '',
            };
          }
          this.isLoading = false;
          this.toastr.success('Profile updated successfully');
        },
        error: (err) => {
          this.isLoading = false;
          this.toastr.error(
            err?.error?.message || err?.message || 'Something went wrong!'
          );
        },
      });
  }
  togglePasswordModal(state: boolean) {
    this.showPasswordModal = state;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
